import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ChevronRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center bg-gray-50 overflow-hidden pt-20" data-id="element-42">
      {/* Background with overlay - reduced shading by 10% */}
      <div className="absolute inset-0 z-0" data-id="element-43">
        <div className="absolute inset-0 bg-gradient-to-b from-white/85 via-white/70 to-white/50 z-10" data-id="element-44" />
        {/* Hero background image */}
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/k6jMXx51o337MuXrpybbFE/hero-bg.jpg)'
      }} data-id="element-45" />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-46">
        {/* Centered content */}
        <div className="max-w-4xl mx-auto text-center" data-id="element-47">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-48">
            <span className="inline-block py-1 px-3 rounded-full bg-blue-50 text-primary font-semibold text-sm mb-6 tracking-wide uppercase" data-id="element-49">
              Confidence • Discipline • Character
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6" data-id="element-50">
              Building Confidence That Lasts — On and Off the Mat
            </h1>
            <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-51">
              We help kids and families grow stronger together through
              structured Taekwondo training that builds discipline, confidence,
              and character in a positive, welcoming environment.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-52">
              <Link to="/trial" data-id="element-53">
                <Button size="lg" className="w-full sm:w-auto group" data-id="element-54">
                  Start Your 4-Week Trial
                  <ChevronRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-55" />
                </Button>
              </Link>
              <Link to="/programs" data-id="element-56">
                <Button variant="outline" size="lg" className="w-full sm:w-auto" data-id="element-57">
                  View Programs
                </Button>
              </Link>
            </div>

            <div className="mt-8 flex items-center justify-center text-sm text-gray-700" data-id="element-58">
              <div className="flex -space-x-2 mr-4" data-id="element-59">
                {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full border-2 border-white bg-gray-200 overflow-hidden" data-id="element-60">
                    <img src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${i}`} alt="Student" className="w-full h-full object-cover" data-id="element-61" />
                  </div>)}
              </div>
              <p data-id="element-62">Trusted by 200+ local families in Brighton</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}